/**
 * List component for transactions, managing list content and implementing event handler
 * 
 * Properties:
 * 
 *      wallets:    array, array of objects containing wallet transactions
 *      dispatch:   function, common dispatch function
 */

import React, { useState, useEffect} from "react";
import { FormatHelper, Biscuit } from "../../../../utils";
import ListItem from "../../../components/ListItem";
import Popup from "../../../components/Popup";
import t from "../../../helpers/t";
import {moment} from '../../../../../vendor';
import {s3Actions, salesBillingsActions, userActions, useSelector} from 'inbooma-api';
import { S3Client } from 'aws_js';
import * as FileSaver from '../../../../../vendor/FileSaver';
import {getApiHost} from "../../../../Sync";
 
 const TransactionsList = (props) => {

    let language = Biscuit.get('user.lang').replace('-','_');

    const walletData = [];
    const _salesBillings = useSelector(state => state.sales_billings_data.salesBillings);
    const _user = useSelector(state => state.users_data.user);
    const [popup,setPopup] = useState({
        open: false,
        linkText: "",
        link: ""
    });
     const _getDocument = useSelector(state => state.s3_data.getDocumentS3);
     const [getDocumentPending, setGetDocumentPending] = useState(false);

     useEffect(() => {
         if(_getDocument.success === '' || !getDocumentPending){
             return;
         }
         if(_getDocument.success === true){
             const blob = new Blob([_getDocument.data], { type: _getDocument.data.type });
             FileSaver.saveAs(blob, getDocumentPending.replace(/_/gi, ' '));
         } else {
             alert('Could not download: ' + _getDocument.data);
         }
         setGetDocumentPending(false);
     }, [_getDocument]);

    useEffect(() => {
        console.log("sales billings: ",_salesBillings);
                if (_salesBillings.success === "") {
                  return;
                }
            
                if (_salesBillings.success === true) {
                    if (_salesBillings.data.length > 0) {
                    // create accumulated invoice
                    _readFile(_salesBillings.data[0]);
                    } else {
                        // no accumulated invoice available from server
                        // ... to-do: show notification
                    }
                    //setSalesBillings([..._salesBillings.data]);
                } else {
                  console.log("Failed fetching sales billing!");
                }
    },[_salesBillings]);

    useEffect(() => {

        if (_user.success == "") return;

        if (_user.success === true) {

            let info = typeof _user.data.first_name !== 'undefined' && _user.data.first_name !== null ? _user.data.first_name : "";
            info += typeof _user.data.last_name !== 'undefined' && _user.data.last_name !== null ? " " + _user.data.last_name : "";

            // show popup with user info and link to user profile
            setPopup({
                left: popup.left,
                top: popup.top,
                open: true,
                text: popup.text,
                link: "users/" + _user.data.id + "?path=/finances/transactions",
                linkText: info.length == 0 ? _user.data.id : info
            });
        } else {
            console.log("Failed to fetch user");
        }
    },[_user]);

    const _readFile = (sales_billing) => {

        const file_name = sales_billing.file;
        props.dispatch(s3Actions.getDocumentS3({
            client_id: Biscuit.get('user.client_id'),
            type: 'SalesBilling',
            location: sales_billing.location_id,
            name: file_name,
            apiEntryPoint: getApiHost(),
            token: Biscuit.get('token')
        }));
        setGetDocumentPending(file_name);

        /*S3Client.getDocument(Number(Biscuit.get('user.client_id')),
                            'SalesBilling',
                            sales_billing.location_id,
                            file_name)
            .then(data => {

                const blob = new Blob([data.Body], { type: data.ContentType });
                FileSaver.saveAs(blob, file_name.replace(/_/gi, ' '));

            })
            .catch((err) => {
                alert(`Error downloading file: ${err}`)
            });*/

    };

    const getPaymentTypeLabel = (pType, pStatus) => {

        let label = "";
         let payment_types = {
             'credit': t('Online payment',null, 'capital')+' '+  t('credit',null,'capital'),
             'PayPal': t('Online payment',null, 'capital')+' '+  t('PayPal',null,'capital'),
             'sepa_debit': t('Online payment',null, 'capital')+' '+ t('sepa',null,'capital'),
             'googlePay': t('Online payment',null, 'capital')+' '+  t('googlePay',null,'capital'),
             'applePay': t('Online payment',null, 'capital')+' '+ t('applePay',null,'capital'),
             'cash': t('Offline payment',null, 'capital')+' '+  t('cash',null,'capital'),
             'Überweisung': t('Offline payment',null, 'capital')+' '+  t('bank_transfer'),
             'EC/Maestro': t('Offline payment',null, 'capital')+' '+t('EC/Maestro'),
             'Visa': t('Offline payment',null, 'capital')+' '+t('Visa'),
             'Mastercard': t('Offline payment',null, 'capital')+' '+t('Mastercard')
         }
        if (pType != null && pType != "") {

            if(typeof payment_types[pType] !== 'undefined'){
                pType = payment_types[pType];
            }
            if (pType == "Payout") {
                label = t('payout_form');
            }
            if (label == "") label = t(pType);

            if (pStatus && pStatus == 'ERROR') {
                label += "";
            }
            else if (pStatus) label += (" " + pStatus);
        }

        return label;
    }

    const fillData = () => {
        if (typeof props.wallets === "undefined") return;

        let wallet;
        let hasOrder = false;
        let hasAccInvoice = false;
        let hasAbo = false;
        for (var i=0;i<props.wallets.length;i++) {
            wallet = props.wallets[i];
            hasOrder = typeof wallet.order !== 'undefined' && wallet.order !== null;
            hasAccInvoice = typeof wallet.accumulated_invoice_id !== 'undefined' && wallet.accumulated_invoice_id !== null ? true : false;
            hasAbo = typeof wallet.abonnement_user_id !== 'undefined' && wallet.abonnement_user_id !== null ? true : false;
            walletData.push({
                elements: [{
                    type: "text",
                    value: "payment_date",
                    title: "",
                    data: [{
                        value: "payment_date",
                        text: moment(wallet.payment_date).format('dd, DD.MM.YYYY, HH:mm'),
                        extraClasses: "text-small",
                        title: t('date',null,'capital'),
                    }],
                    mediumWidth: 3,
                    smallWidth: 3,
                    handler: onItemClickedHandler
                },{
                    type: "text",
                    value: hasAccInvoice ? "acc_invoice" : "order_nbr",
                    title: "",
                    extraTopClasses: "item-inline",
                    data: [{
                        value: hasAccInvoice ? "acc_invoice_" + wallet.accumulated_invoice_id : hasOrder ? "order_nbr" : hasAbo ? "abonnement_id" : "",
                        text: hasAccInvoice ? t('invoice') + ' ' + wallet.accumulated_invoice_id : hasOrder ? wallet.order_nbr + ' ' + t(wallet.order_status) +' ' : hasAbo ? t('abonnement',null,'capital') + ' ' + wallet.abonnements_user?.abonnement?.description : '',
                        extraClasses: "text-small",
                        title: hasAccInvoice ? t('invoice',null,'capital') : hasOrder ? t('order_nbr',null,'capital'): hasAbo ? t('abonnement',null,'capital') : '-',
                        ref: hasAccInvoice ? '#' : (hasOrder ? '/reservations/reservationsList?order_nbr='+wallet.order_nbr : '#')
                    },{
                        value: "order_payment",
                        text: hasOrder ? ' ' + FormatHelper.currencyFormat(wallet.order.paid) + ' ' + wallet.currency + ' ' : '',
                        extraClasses: "text-small",
                        title: t('payments',null,'capital')
                    },{
                        value: hasOrder ? (typeof wallet.order.user_id !== 'undefined' || wallet.order.user_id !== null ? 'user_' + wallet.order.user_id : 'User') : hasAbo ? (typeof wallet.abonnements_user?.user_id !== 'undefined' || wallet.abonnements_user?.user_id !== null ? 'user_' + wallet.abonnements_user?.user_id : 'User') : 'User',
                        text: " ",
                        icon: (hasOrder || hasAbo) ? "fi fi-torso" : 'fi',
                        extraClasses: "text-small",
                        extraStyle: {paddingLeft:"8px"},
                        title: t('show_user',null,'capital'),
                        ref: 'users?id='+wallet.order.user_id
                    },{
                        value: "order_payment_link",
                        text: "",
                        icon: hasOrder ? "fi fi-euro" : 'fi',
                        extraClasses: "text-medium",
                        title: t('show_payment',null,'capital'),
                        extraStyle: {paddingLeft:"8px"},
                        ref: hasOrder ? '/orders/' + wallet.order.id + '/addpaymentfromwallet' : '#'
                    },{
                        value: "order_payment",
                        text: '',
                        extraClasses: "text-small",
                        title: t('price',null,'capital')
                    }],
                    mediumWidth: 3,
                    smallWidth: 3,
                    handler: onItemClickedHandler
                },{
                    type: "text",
                    value: "payment_type",
                    title: "",
                    extraTopClasses: "item-inline",
                    data: [{
                        value: "payment_type",
                        text: getPaymentTypeLabel(wallet.payment_type, wallet.payment_status),
                        extraClasses: "text-small",
                        title: t('payment_type',null,'capital')
                    },{
                        value: (wallet.payment_status && wallet.payment_status == "ERROR") ? "payment_info_" + i : "payment_info",
                        icon: (wallet.payment_status && wallet.payment_status == "ERROR") ? "fi fi-info" : "fi",
                        extraClasses: "text-small",
                        title: (wallet.payment_status && wallet.payment_status == "ERROR")?wallet.message:"",
                        extraStyle: {paddingLeft:"8px"},
                        ref: '#'
                    }],
                    mediumWidth: 2,
                    smallWidth: 2,
                    handler: onItemClickedHandler
                },{
                    type: "text",
                    value: "payment_reference",
                    title: "",
                    data: [{
                        value: "payment_reference",
                        text: wallet.reference,
                        extraClasses: "text-small word-break-all",
                        title: t('payment_reference',null,'capital')
                    }],
                    mediumWidth: 2,
                    smallWidth: 2,
                    handler: onItemClickedHandler
                },{
                    type: "text",
                    value: "client_payment_amount",
                    title: "",
                    extraTopClasses: "text-right item-inline",
                    data: [{
                        value: "client_payment_amount",
                        text: FormatHelper.currencyFormat(wallet.credit == 0 ? (wallet.debit < 0.00 ? (wallet.debit * -1.00) : "-" + wallet.debit): wallet.credit),
                        title: "",
                        extraClasses: "text-small text-bold"},{
                        value: "client_payment_currency",
                        text: " " + wallet.currency,
                        title: "",
                        extraClasses: "text-small",
                    }],
                    mediumWidth: 2,
                    smallWidth: 2,
                    handler: onItemClickedHandler
                }]
            });
        }
    };

    const onItemClickedHandler = (value) => {

        console.log("clicked on: ", value);
        if (value.startsWith('acc_invoice_')) {

            // open accumulated invoice
            const id = value.split('acc_invoice_')[1];

            props.dispatch(salesBillingsActions.getSalesBillings({
                token: Biscuit.get('token'),
                suffix: "",
                filter: {
                    page: 1,
                    accumulated_invoice_id: id
                },
                parameters: {
                    headers: {
                        'Accept-Language': language,
                        'Content-Language': language
                    }
                }
            }));
        }
        if (value.startsWith('user_')) {

            // fetch user info
            const id = value.split('user_')[1];
            const el_rect = document.getElementsByName(value)[0].getBoundingClientRect();

            props.dispatch(userActions.getUser({
                token: Biscuit.get('token'),
                id: id
            }));

            setPopup({
                ...popup,
                left: el_rect.left + "px",
                top: el_rect.top + "px",
                text: t('user',null,'capital') + ':'
            });
        }
        if (value.startsWith('payment_info_')) {

            const idx = value.split('payment_info_')[1];
            const el_rect = document.getElementsByName(value)[0].getBoundingClientRect();

            setPopup({
                ...popup,
                left: el_rect.left + "px",
                top: el_rect.top + "px",
                open: true,
                text: t('payment_error_info') + ": " + props.wallets[idx].message,
                link: "",
                linkText: ""
            });
        }
    };

    const popupCloseHandler = () => {

        setPopup({
            ...popup,
            open: false
        });
    };

    fillData();
 
    return (
        <div className={'inb-c-listing'+(props.subClass !== 'undefined'?props.subClass:"")}>
        {typeof props.wallets !== 'undefined' && props.wallets.map((wallet, index) => {
            return (
                <ListItem
                    key={"wti-" + index}
                    listStyle="tight"
                    id={"wallet-transactions-item-" + index}
                    elements={walletData[index].elements}/>
            )})}
        {popup.open === true &&
            <Popup
                left={popup.left}
                top={popup.top}
                linkText={popup.linkText}
                text={popup.text}
                link={popup.link}
                onCloseHandler={popupCloseHandler}/>
        }
        </div>
    );
 };
 export default TransactionsList;